import { format } from 'date-fns';

export const getDateFormat = (date, dateFormat, isShort) => {
  if (!date) return '';
  const today = new Date();
  const selectedDate = new Date(date.replace(/-/g, '/').replace('T', ' ').replace('Z', ''));

  if (isShort) {
    if (
      selectedDate.getDate() === today.getDate() &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getFullYear() === today.getFullYear()
    ) {
      return `Today, ${format(selectedDate, 'h:mm aa')}`;
    } else if (
      selectedDate.getDate() === today.getDate() - 1 &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getFullYear() === today.getFullYear()
    ) {
      return `Yesterday, ${format(selectedDate, 'h:mm aa')}`;
    }
  }

  return format(selectedDate, dateFormat);
};
